export default "__VITE_ASSET__a751853a__"